import axios from "axios";

const locationAPI = axios.create({
  baseURL: "https://missionmap-lc.onrender.com/api/location",
});

locationAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default locationAPI;
